import { Link, useParams } from 'react-router-dom'
import { Stack, Typography } from '@mui/material';


interface ComposersNamesProps {
    track: Track,
    defaultNames: string,
    clear: boolean
}

export const ComposersNames = (props: ComposersNamesProps) => {
    let { id } = useParams()

    let textColor = ! props.clear && props.track && props.track.apple_artwork_bg ? '#'+props.track.apple_artwork_bg : '#ffffff'

    let style = {
        maxWidth: ((100 / (props.track && props.track.producers != null ? props.track.producers?.length : 1)))+'%',
        '& a' : {
            fontSize: '0.8rem', 
            color: textColor
        },
        overflow: 'hidden', 
        whiteSpace: 'nowrap',
        textUnderlineOffset: '3px', 
        textOverflow: 'ellipsis',
        pl: 0.4
    }

    return <Stack spacing={0} direction="row" justifyContent={'flex-end'} sx={{color: textColor, fontSize: '0.8rem', lineHeight: '2rem'}}>{
        props.track && props.track.producers && props.track.producers.length > 0
            ? props.track.producers.map( (artist: Artist, i: number) =>  {
                return props.track.producers && i === props.track.producers.length - 1
                ? <Typography 
                    key={i + artist._id} 
                    sx={{...style, ...{textDecoration: artist._id === id ? 'none' : 'underline'}}}>
                    <Link to={`/artist/${artist._id}`} >{artist.artist_name }</Link>
                </Typography>
                :  <><Typography 
                    key={i + artist._id} 
                    sx={{...style, ...{textDecoration: artist._id === id ? 'none' : 'underline'}}}>
                    <Link to={`/artist/${artist._id}`}>{ artist.artist_name }</Link> 
                </Typography>{', '}</>
            })
            : props.defaultNames
    }</Stack>      
}
